// Live attendance-timer elapsed time, immune to a skewed device clock.
//
// The backend returns `duration_seconds` for an open tracker — the elapsed
// time computed against the SERVER clock at the moment of the response. If the
// frontend instead computes `Date.now() - start_time`, any device whose local
// clock drifts (commonly 5–15 min ahead) makes the timer appear to start
// already-elapsed.
//
// To stay correct we anchor to the server value: when we receive a tracker we
// remember (a) the server's elapsed at that instant and (b) the LOCAL clock at
// that instant. Afterwards elapsed = serverBase + (localNow - localAnchor).
// Both sides of the delta come from the same device clock, so its absolute
// offset cancels out — only the (accurate) tick rate is used.

export function anchorTracker(t) {
  if (!t) return t;
  return {
    ...t,
    _baseMs: Math.max(0, Number(t.duration_seconds) || 0) * 1000,
    _anchorAt: Date.now(),
  };
}

export function trackerElapsedMs(t, now) {
  if (!t) return 0;
  const base = t._baseMs ?? 0;
  const at = t._anchorAt ?? now;
  return Math.max(0, base + (now - at));
}
